<template>
  <div>
    <div @click="showModal">
      <slot name="popupTrigger"></slot>
    </div>

    <portal to="mainPortal">
      <modal
        :name="this.name"
        transition="fade_down"
        :clickToClose="true"
        width="90%"
        height="auto"
        :delay="200"
        :adaptive="true">

          <slot name="popupContent"></slot>

        <div slot="top-right">
          <button @click="closeModal" class="btn shadow-lg bg-black p-2 hover:bg-red">
            <svg-icon name="x" classes="w-10 h-10 text-white"></svg-icon>
          </button>
        </div>
      </modal>
    </portal>
  </div>
</template>

<script>
export default {
  name: "Popup",

  props: {
    name: {
      type: String,
      required: true
    }
  },

  methods: {
    showModal() {
      this.$modal.show(this.name)
    },

    closeModal() {
      this.$modal.hide(this.name)
    }
  }
}
</script>